import { styled } from '@mui/material';
import { BaseCard } from 'console/shared/styles/mixins/base-card';
export const VehicleCustomControls = styled(BaseCard)({
    padding: 8,
    fontSize: 'inherit',
    height: 'auto',
    width: '100%',
});
